var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "main_form" },
        [
          _c(
            "el-form",
            {
              ref: "queryForm",
              attrs: { inline: true, model: _vm.queryModel, size: "small" }
            },
            [
              _c(
                "el-form-item",
                { staticClass: "search_form_item", attrs: { prop: "userId" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("m.live_ID"), clearable: "" },
                    model: {
                      value: _vm.queryModel.userId,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.queryModel,
                          "userId",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "queryModel.userId"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "search_form_item", attrs: { prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("m.remark"),
                      maxlength: "200",
                      clearable: "",
                      filterable: ""
                    },
                    model: {
                      value: _vm.queryModel.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.queryModel, "remark", $$v)
                      },
                      expression: "queryModel.remark"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "search_form_item",
                  attrs: { prop: "contractStatus" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("m.sign_status"),
                        clearable: ""
                      },
                      model: {
                        value: _vm.queryModel.contractStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.queryModel, "contractStatus", $$v)
                        },
                        expression: "queryModel.contractStatus"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { value: 1, label: _vm.$t("m.sign_ing") }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: {
                          value: 0,
                          label: _vm.$t("m.subscription_closed")
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "contractStartTime" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          placeholder: _vm.$t("m.sign_time")
                        },
                        model: {
                          value: _vm.queryModel.contractStartTime,
                          callback: function($$v) {
                            _vm.$set(_vm.queryModel, "contractStartTime", $$v)
                          },
                          expression: "queryModel.contractStartTime"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "fc-text-center", attrs: { span: 1 } },
                    [_vm._v("~")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          placeholder: _vm.$t("m.sign_time")
                        },
                        model: {
                          value: _vm.queryModel.contractEndTime,
                          callback: function($$v) {
                            _vm.$set(_vm.queryModel, "contractEndTime", $$v)
                          },
                          expression: "queryModel.contractEndTime"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          placeholder: _vm.$t("m.apply_time")
                        },
                        model: {
                          value: _vm.queryModel.applyStartTime,
                          callback: function($$v) {
                            _vm.$set(_vm.queryModel, "applyStartTime", $$v)
                          },
                          expression: "queryModel.applyStartTime"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "fc-text-center", attrs: { span: 1 } },
                    [_vm._v("~")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          placeholder: _vm.$t("m.apply_time")
                        },
                        model: {
                          value: _vm.queryModel.applyEndTime,
                          callback: function($$v) {
                            _vm.$set(_vm.queryModel, "applyEndTime", $$v)
                          },
                          expression: "queryModel.applyEndTime"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "search_form_item" },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("m.live_state_placeholder"),
                        clearable: ""
                      },
                      model: {
                        value: _vm.queryModel.isProhibitLive,
                        callback: function($$v) {
                          _vm.$set(_vm.queryModel, "isProhibitLive", $$v)
                        },
                        expression: "queryModel.isProhibitLive "
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          value: false,
                          label: _vm.$t("m.live_state_open")
                        }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: {
                          value: true,
                          label: _vm.$t("m.live_state_temporary_banned")
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-wrapper" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: _vm.searchBtnTrue,
                    type: "primary",
                    size: "small"
                  },
                  on: { click: _vm.onQueryBtnClick }
                },
                [_vm._v(_vm._s(_vm.$t("m.search")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "text", size: "mini" },
                  on: { click: _vm.resetForm }
                },
                [_vm._v(_vm._s(_vm.$t("m.reset")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main_table" },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-operation",
              staticStyle: { "margin-bottom": "10px" },
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.doExportUserDate }
            },
            [_vm._v(_vm._s(_vm.$t("m.exported_data")))]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading.table,
                  expression: "loading.table"
                }
              ],
              ref: "tableOrder",
              staticStyle: { width: "100%", "margin-bottom": "10px" },
              attrs: {
                data: _vm.tableData,
                border: "",
                "row-class-name": _vm.tableRowClassName,
                "element-loading-text": "",
                "element-loading-spinner": "el-icon-loading"
              }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "userId", label: _vm.$t("m.live_ID") }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "nickName",
                  label: _vm.$t("m.sereamer_nickname")
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "sex", label: _vm.$t("m.gender") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.sex === 0
                          ? _c("span", [_vm._v(_vm._s(_vm.$t("m.female")))])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.sex === 1
                          ? _c("span", [_vm._v(_vm._s(_vm.$t("m.male")))])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "img", label: _vm.$t("m.avatar") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("img", {
                          staticClass: "img-thumb",
                          attrs: {
                            src:
                              scope.row.img ||
                              require("../../assets/img/photo.png")
                          },
                          on: {
                            click: function($event) {
                              return _vm.showPicPreviewDialog(scope.row)
                            }
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "remark",
                  label: _vm.$t("m.remark"),
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.remark
                          ? [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    size: "mini",
                                    type: "danger",
                                    closable: ""
                                  },
                                  on: {
                                    close: function($event) {
                                      return _vm.removeUserRemark(scope.row)
                                    }
                                  }
                                },
                                [_c("span", [_vm._v(_vm._s(scope.row.remark))])]
                              )
                            ]
                          : [
                              _c(
                                "el-tag",
                                { attrs: { type: "info", size: "mini" } },
                                [_vm._v(_vm._s(_vm.$t("m.no_remark")))]
                              )
                            ],
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _c(
                              "el-tag",
                              {
                                staticClass: "cursor-pointer",
                                attrs: { type: "success", size: "mini" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.openUserRemarkDialog(scope.row)
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "el-icon-plus" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("m.add_remark")) +
                                    "\n            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: _vm.$t("m.user_status") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.status === 1
                          ? _c("span", [_vm._v(_vm._s(_vm.$t("m.normal")))])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 2
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("m.temporarily_frozen")))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 3
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("m.permanently_frozen")))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 4
                          ? _c("span", [_vm._v(_vm._s(_vm.$t("m.cancelled")))])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "birthday", label: _vm.$t("m.birth") }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "liveId", label: _vm.$t("m.live_room_ID") }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "fansNum", label: _vm.$t("m.fans_num") }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "email",
                  label: _vm.$t("m.email"),
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.emailState === false
                          ? _c("img", {
                              attrs: {
                                width: "24",
                                src: require("../../assets/search.png")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getDetailInfo(
                                    scope.row,
                                    "emailState"
                                  )
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.emailState === true
                          ? _c("span", [_vm._v(_vm._s(scope.row.email))])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "whatsApp", label: "WhatsApp" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.whatsappState === false
                          ? _c("img", {
                              attrs: {
                                width: "24",
                                src: require("../../assets/search.png")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getDetailInfo(
                                    scope.row,
                                    "whatsappState"
                                  )
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.whatsappState === true
                          ? _c("span", [_vm._v(_vm._s(scope.row.whatsApp))])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "faceBook", label: "Facebook" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.facebookState === false
                          ? _c("img", {
                              attrs: {
                                width: "24",
                                src: require("../../assets/search.png")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getDetailInfo(
                                    scope.row,
                                    "facebookState"
                                  )
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.facebookState === true
                          ? _c("span", [_vm._v(_vm._s(scope.row.faceBook))])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "instagram", label: "Instagram" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.instagramState === false
                          ? _c("img", {
                              attrs: {
                                width: "24",
                                src: require("../../assets/search.png")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getDetailInfo(
                                    scope.row,
                                    "instagramState"
                                  )
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.instagramState === true
                          ? _c("span", [_vm._v(_vm._s(scope.row.instagram))])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "mobile", label: _vm.$t("m.phone") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.phoneState === false
                          ? _c("img", {
                              attrs: {
                                width: "24",
                                src: require("../../assets/search.png")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getDetailInfo(
                                    scope.row,
                                    "phoneState"
                                  )
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.phoneState === true
                          ? _c("span", { staticClass: "direction_ltr" }, [
                              _vm._v(
                                _vm._s(
                                  scope.row.areaCode
                                    ? "+" + scope.row.areaCode
                                    : ""
                                ) + _vm._s(scope.row.mobile)
                              )
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "lang", label: _vm.$t("m.mastery_lang") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm._f("langFilt")(scope.row.lang)) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "contractStatus",
                  label: _vm.$t("m.sign_status")
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "#54a8fc",
                              cursor: "pointer"
                            },
                            on: {
                              click: function($event) {
                                return _vm.openSignContractDialog(scope.row)
                              }
                            }
                          },
                          [
                            scope.row.contractStatus === 1
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.$t("m.sign_ing")))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.contractStatus === 0
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("m.subscription_closed"))
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "signDt", label: _vm.$t("m.sign_time") }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "cancelDt", label: _vm.$t("m.release_time") }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "applyTime", label: _vm.$t("m.apply_time") }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: _vm.$t("m.live_viola_record"), width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function($event) {
                                return _vm.openLiveViolationLogDialog(scope.row)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("m.view")))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("m.live_state_placeholder"),
                  width: "100",
                  prop: "liveFlagName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.pager.page,
              "page-sizes": [10, 20, 30, 100, 300, 500],
              "page-size": _vm.pager.limit,
              small: "",
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pager.total,
              "pager-count": 5
            },
            on: {
              "size-change": _vm.onSizeChange,
              "current-change": _vm.onCurrentPageChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialog.picPreview.show,
            title: _vm.$t("m.preview"),
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.dialog.picPreview, "show", $event)
            }
          }
        },
        [
          _c("img", {
            staticClass: "img-preview",
            attrs: { src: _vm.dialog.picPreview.picSrc }
          })
        ]
      ),
      _vm._v(" "),
      _c("sign-contract-dialog", {
        ref: "signContractDialog",
        on: { done: _vm.query }
      }),
      _vm._v(" "),
      _c("live-violation-log-dialog", {
        ref: "liveViolationLogDialog",
        on: { done: _vm.query }
      }),
      _vm._v(" "),
      _c("user-remark-dialog", {
        ref: "userRemarkDialog",
        on: {
          done: function($event) {
            return _vm.getTableData()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38bdd9bf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38bdd9bf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/approval/anchorApprovalPage.vue
// module id = null
// module chunks = 